export let baseAPI;

if(process.env.NODE_ENV === 'development')
{
    baseAPI = 'http://localhost:8000/';
}
else
{
    baseAPI = 'https://akreaturni.loripsumhosting.it/api/';
}